import { createContext } from 'react';

const bottomAdContext = createContext({
  animateShow: false,
  setAnimateShow: () => {},
});
export default bottomAdContext;
